import { render, staticRenderFns } from "./Younger.vue?vue&type=template&id=2725dc5e&"
import script from "./Younger.vue?vue&type=script&lang=ts&"
export * from "./Younger.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports